// extracted by mini-css-extract-plugin
export default {"cloud_wrap":"styles_cloud_wrap__fXj-L","bottomPadded":"styles_bottomPadded__rpPv-"};